export enum DirectoryItemArrowColor {
  DEFAULT = 'default',
  NEUTRAL = 'neutral',
}

export enum DirectoryItemAlignment {
  CENTER = 'center',
  TOP = 'top',
}
